import type { AttributeType, SubjectType } from '@aytm/app/insights/dashboard/models/types.ClientDTO'
import type { SortOrder } from '@aytm/app/insights/dashboard/models/BlockModel'
import { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'

export type StateSelectorParams = {
  subjects: Record<string, SubjectType>
  attributes: Record<string, AttributeType>
  sortByAttribute?: string
  showSigtest?: boolean
  sortByMethod?: string
  currentSplit?: string
  sortOrder?: SortOrder
  editorMode: boolean
  chartAttribute: string | null
}

export const stateSelector = (state: InsightsDashboardPoolState): StateSelectorParams => {
  const block = getCurrentBlock(state)
  const subjects = state.currentData?.subjects || {}
  const attributes = state.currentData?.attributes || {}
  const sortByAttribute = block?.get<string>('sortByAttribute') || null
  const showSigtest = block?.get<boolean>('showSigtest') || false
  const sortByMethod = block?.get<string>('sortByMethod') || null
  const currentSplit = block?.get<string>('currentSplit') || null
  const sortOrder = block?.get<SortOrder>('sortOrder') || null
  const chartAttribute = block?.get<string>('chartAttribute') || null
  const roles = state.accessKey?.roles || []
  const editorMode = roles && roles.includes('editor')
  return {
    subjects,
    attributes,
    sortByAttribute,
    showSigtest,
    sortByMethod,
    currentSplit,
    sortOrder: sortByAttribute && 'letters' !== sortOrder ? sortOrder : null,
    editorMode,
    chartAttribute
  }
}

export const shouldUpdate = (prev: StateSelectorParams, next: StateSelectorParams) =>
  !prev && !next
    ? false
    : prev.subjects === next.subjects ||
      prev.attributes === next.attributes ||
      prev.sortByAttribute === next.sortByAttribute ||
      prev.showSigtest === next.showSigtest ||
      prev.sortByMethod === next.sortByMethod ||
      prev.currentSplit === next.currentSplit ||
      prev.sortOrder === next.sortOrder ||
      prev.editorMode === next.editorMode ||
      prev.chartAttribute === next.chartAttribute
